import type { SeptFlash48Variant } from '../constants/sept-flash-48';

export const SEPT_FLASH_48_G1_PROMOTION_ID = 'sept48';
export const SEPT_FLASH_48_G2_PROMOTION_ID = 'septflash';

export type SeptFlash48MarketTier = 'full' | 'low';

export function getSeptFlash48MarketTier(variant: SeptFlash48Variant): SeptFlash48MarketTier {
  return variant === 'g2' ? 'low' : 'full';
}

export function getSeptFlash48Variant(promotionId: string | null | undefined): SeptFlash48Variant | null {
  if (promotionId === SEPT_FLASH_48_G1_PROMOTION_ID) {
    return 'g1';
  }
  if (promotionId === SEPT_FLASH_48_G2_PROMOTION_ID) {
    return 'g2';
  }
  return null;
}

export function getSeptFlash48SlideKey(variant: SeptFlash48Variant): string {
  return `sept-flash-48-${variant}`;
}

export function resolveSeptFlash48Variant(
  forcedPromotionId: string | null | undefined,
  promotionId: string | null | undefined
): SeptFlash48Variant | null {
  return getSeptFlash48Variant(forcedPromotionId) ?? getSeptFlash48Variant(promotionId);
}
